import React from 'react';

interface ContentLoadingFallbackProps {
  message?: string;
}

const ContentLoadingFallback: React.FC<ContentLoadingFallbackProps> = ({ 
  message = "Loading..." 
}) => {
  return (
    <div className="flex items-center justify-center p-8 min-h-[200px]">
      <div className="text-white/70 text-sm flex items-center space-x-3">
        <div className="animate-spin w-5 h-5 border-2 border-white/30 border-t-white/70 rounded-full"></div>
        <span className="font-medium">{message}</span>
      </div>
    </div>
  );
};

export default ContentLoadingFallback;
